import { CacheType } from '@descomplica/caching-browser';
import {
  BaseHttpGateway,
  CollaborationResult,
  RecognitionManager,
} from '@descomplica/microfrontend-core';
import axios from 'axios';
import { injectable } from 'tsyringe';

import type {
  CertificateDto,
  IPegasusGateway,
} from '@/application/interfaces/certificate/pegasus.gateway';
import { UserDto } from '@/application/interfaces/pegasus.gateway';
import envs from '@/infrastructure/config/envs';

@injectable()
export class PegasusGateway extends BaseHttpGateway implements IPegasusGateway {
  constructor(private readonly recognitionManager: RecognitionManager) {
    super();
  }

  async getIdentifiedUser(): Promise<CollaborationResult<UserDto>> {
    const { data } = await this.axios.get(`/identified-user`);
    return data;
  }

  async getCertificate(courseGuid: string): Promise<CollaborationResult<CertificateDto>> {
    const { data } = await this.axios.get(`/certificate/generate/course/${courseGuid}`);
    return data;
  }

  async getPublicCertificate(certificateGuid: string): Promise<CollaborationResult<any>> {
    const { data } = await axios.get(
      `${envs.pegasusUrl}/certification/public/certificate/${certificateGuid}`,
    );
    return data;
  }

  protected getEndpoint(): string {
    return `${envs.pegasusUrl}/application-management`;
  }

  protected getCacheType(): CacheType {
    return CacheType.LOCALSTORAGE;
  }

  protected getCacheNamespace(): string {
    return 'certifcate-pegasus-lms-gateway';
  }

  protected getBearerToken(): string {
    return this.recognitionManager.getAccessToken();
  }

  protected getHeaders(): object {
    const headers = {};
    headers['Cache-Control'] = 'no-cache';
    headers['Pragma'] = 'no-cache';
    headers['Expires'] = '0';
    return headers;
  }
}
